var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C5.30682 0 5.55556 0.230254 5.55556 0.514286V7.50126L7.19976 5.9792C7.41671 5.77836 7.76847 5.77836 7.98543 5.9792C8.20239 6.18004 8.20239 6.50567 7.98543 6.70651L5.39284 9.10651C5.17588 9.30735 4.82412 9.30735 4.60716 9.10651L2.01457 6.70651C1.79761 6.50567 1.79761 6.18004 2.01457 5.9792C2.23153 5.77836 2.58329 5.77836 2.80024 5.9792L4.44444 7.50126V0.514286C4.44444 0.230254 4.69317 0 5 0ZM0 11.4857C0 11.2017 0.248731 10.9714 0.555556 10.9714H9.44444C9.75127 10.9714 10 11.2017 10 11.4857C10 11.7697 9.75127 12 9.44444 12H0.555556C0.248731 12 0 11.7697 0 11.4857Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.be48fecc3847ce0d17b5ae050e849211.svg";
export { ForwardRef as ReactComponent };